import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PiecesDL from '../PiecesDL/PiecesDL';
import AddConversationButton from './AddConversationButton';
import SuiviColisModal from './SuiviColisModal';
import RippleEffect from '../Ripple/RippleEffect';
import { hexToRgbA, getFrDate } from '../../Utils';
import { confs } from '../../conf';
import qs from 'qs';

const { PRIMARY_BG } = confs;

const style = {
  card: {
    display: 'flex',
    alignItems: 'center',
    padding: '.5rem',
    justifyContent: 'space-between'
  },
  content: {
    flex: '1',
  },
  h1: {
    fontSize: '24px',
    color: PRIMARY_BG,
    paddingLeft: '.5rem',
    borderLeft: '3px solid '+PRIMARY_BG,
    minHeight: '40px',
  },
  logo: {
    color: 'rgba('+hexToRgbA(PRIMARY_BG)+', .5)',
    marginRight: '1rem',
    fontSize: '3rem',
  },
  title: {
    color: PRIMARY_BG,
    fontWeight: 'bold',
    fontSize: '18px',
    position: 'relative',
  },
  tools: {
    display: 'flex',
  }
};

const FactureCard = ({ facture, selected }) => (
    <div className={'ripple'} style={{...style.card, border: selected ? 'solid red' : 'none'}}>

      <div style={style.logo}>
        <i className={"fa fa-file-pdf"}></i>
      </div>
      <div style={style.content} className={"ml-2"}>
        <div style={style.title}>
          {facture.numfac}
        </div>
        <div>
          <small>{getFrDate(facture.date_fac)}</small>
        </div>
      </div>

      <div style={style.tools}>

        <AddConversationButton style={{color: PRIMARY_BG}} piece={facture.facture} echange={facture.echange} />

      </div>

    </div>
);

class FacturesList extends Component {

  componentDidMount() {
    const params = qs.parse(this.props.location.search.replace('?', '')) || 0;
    let el = document.getElementById(params.show);
    if (el) {
      let top = el.getBoundingClientRect();
      window.scrollTo(0, top.y - 100);
    }
  }

  render() {
    const { factures, onClickCallback, selectedDocName, selectedDocNum } = this.props;
    const params = qs.parse(this.props.location.search.replace('?', '')) || 0;
    return (
      <div className={"container"}>
        <div className={"row justify-content-center"}>
          <div className={"col-md-12"}>
            <h1 style={style.h1}>Factures</h1>
            {
              factures && factures.map((facture, key) => (
                <div key={key} id={facture.numfac} className={(params.show == facture.numfac && params.typ === 'FAC') ? 'show-ilsduc': ''} onClick={(e) => onClickCallback(facture, "facture", facture.numfac)}>
                  <FactureCard facture={facture} selected={selectedDocName === "facture" && selectedDocNum === facture.numfac} />
                </div>
              ))
            }
            {
              factures && factures.length <= 0 &&
                <div className={"ml-3"}> Pas de facture</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(FacturesList);
